import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {FilePdfOutlined} from "@ant-design/icons";
import i18n from "i18next";
import {message, Spin} from "antd";
import ReportService from "../services/report.service";
import moment from "moment";
import fileDownload from "js-file-download";
import AuthService from "../services/auth.service";
import {gaEventWithUserIdLabel, LOG_OUT} from "../constants";

class PdfDownloadLink extends Component {

    constructor(props) {
        super(props);

        this.state = {
            spinning: false
        }
    }

    downloadPDF(itemId, searchId, event) {

        this.spinning(itemId);

        ReportService.downloadPDF(itemId)
            .then(
                response => {
                    this.unSpinning(itemId);

                    if (response.data) {

                        let blob = new Blob([response.data], {type: 'application / PDF'})
                        if (blob.size > 313) {
                            const pdfFilename = "Search Sanctions AML Search Report " + (searchId ? "(" + searchId + ") " : "") + moment(new Date()).format("YYYY MM DD") + ".pdf";
                            fileDownload(response.data, pdfFilename)
                        } else {
                            message.error(i18n.t('global_error'))
                        }
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {
                    this.unSpinning(itemId);

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("ReportService.downloadPDF Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )

        event.preventDefault()
    }

    spinning(itemId) {
        // let spinnings = this.state.spinnings
        // spinnings[itemId] = true

        this.setState({
            spinning: true
        })
    }

    unSpinning(itemId) {
        // let spinnings = this.state.spinnings
        // spinnings[itemId] = false

        this.setState({
            spinning: false
        })
    }

    render() {

        let {spinning} = this.state
        let {itemId, searchId, className} = this.props

        return (
            <Spin spinning={spinning}>
                <a onClick={event => {
                    this.downloadPDF(itemId, searchId, event)
                }} href="#">
                    <div className={className}>
                        <div className="color-red">
                            <FilePdfOutlined/>
                        </div>
                        {i18n.t('pdfDownload')}
                    </div>
                </a>
            </Spin>
        )
    }

}

function mapStateToProps(state) {
    return {
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PdfDownloadLink);